import React from 'react'
import TopPageCarousel from '@/components/modules/TopPage/Carousel'
import TopPageCards from '@/components/modules/TopPage/TopPageCards'

export default function TopPage() {
  return (
    <>
      <TopPageCarousel/>
      <TopPageCards/>
    </>
  )
}